module.exports = __webpack_public_path__ + "static/media/Logo.37dbdd77.svg";